import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../../../axios";
import CoverDesignForm from "./CoverDesignForm";
import ErrorModal from "../../components/ErrorModal";
import handleApiError from "../../../utils/handleApiError";
import SuccessModal from "../../components/SuccessModal";

export default function CoverDesignEditPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [form, setForm] = useState({ name: "", image: "" });
    const [image, setImage] = useState(null);

    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        axios.get(`/admin/cover-designs/${id}`).then(res => {
            setForm(res.data);
        });
    }, [id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append("name", form.name);
        if (image) data.append("image", image);

        try {
            await axios.post(`/admin/cover-designs/${id}?_method=PUT`, data);
            setSuccess("Data berhasil diubah!");
        } catch (err) {
            setError(handleApiError(err));
        } finally {
            setLoading(false);
        }

    };

    return (
        <>
            <ErrorModal error={error} onClose={() => setError("")} />
            <SuccessModal
                message={success}
                onClose={() => {
                    setSuccess("");
                    navigate("/admin/cover-designs");
                }}
            />
            <CoverDesignForm
                form={form}
                setForm={setForm}
                image={image}
                setImage={setImage}
                onSubmit={handleSubmit}
                title="Edit Cover Designs"
                buttonLabel="Update"
            />
        </>

    );
}
